<template>
  <div class="shop-content_wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-md-5 order-2 order-lg-1 order-md-1">
            <div class="uren-sidebar-catagories_area">
              <div class="category-module uren-sidebar_categories">
                <categories />
              </div>
              
            </div>
            
          </div>
          <div class="col-lg-9 col-md-7 order-1 order-lg-2 order-md-2">

          <ArticleCard></ArticleCard>


          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Categories from '../../components/Categories.vue';
import ShopProducts from './../../shop_products.json';
import DisplayProducts from './components/DisplayProducts.vue';
import ArticleCard from './components/articleCards.vue';
export default {
  name: "Shop",
  components: {
    Categories,
    DisplayProducts,
    ArticleCard
  },
  data() {
    return {
      products : ShopProducts.products,
      sortOptions: [
        {
          value: 1,
          title: 'Default'
        },
        {
          value: 2,
          title: 'Name, A to Z'
        },
        {
          value: 3,
          title: 'Name, Z to A'
        },
        {
          value: 4,
          title: 'Price, low to high'
        },
        {
          value: 5,
          title: 'Price, high to low'
        },
        {
          value: 6,
          title: 'Rating (Highest)'
        },
        {
          value: 7,
          title: 'Rating (Lowest)'
        },
        {
          value: 8,
          title: 'Model (A - Z)'
        },
        {
          value: 9,
          title: 'Model (Z - A)'
        },
      ],
      showOptions: [5, 10, 20, 50, 100],
    }
  }
}
</script>

<style>

</style>
